function DateInput({
  label = defaultValues.label,
  changeEvent = defaultValues.changeEvent,
  id =  defaultValues.id,
  generalClass = defaultValues.generalClass,
  classLeft = defaultValues.classLeft,
  classRight = defaultValues.classRight,
  minDate
}) {
  return (
    <div className={generalClass}>
        <div className={classLeft}>
            <label><strong>{label} :</strong></label>
        </div>
        <div className={classRight}>
            <input type="date" id={id} onChange={changeEvent} min={minDate} />
        </div>
    </div>
  )
}

const emptyFunction = () => {}

const defaultValues = {
  label: 'Example',
  changeEvent: emptyFunction,
  id: 'defaultSelect',
  generalClass: 'doubleColumnBenefit',
  classLeft: 'leftColumn',
  classRight: 'rightColumn'
}

export default DateInput